import { render, staticRenderFns } from "./SuggestionBoxInfo.vue?vue&type=template&id=6963832a&scoped=true"
import script from "./SuggestionBoxInfo.vue?vue&type=script&lang=js"
export * from "./SuggestionBoxInfo.vue?vue&type=script&lang=js"
import style0 from "./SuggestionBoxInfo.vue?vue&type=style&index=0&id=6963832a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963832a",
  null
  
)

/* custom blocks */
import block0 from "./SuggestionBoxInfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports